export default "__VITE_PUBLIC_ASSET__8ad93c96__"